import React from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePickerContainer } from './styles';
import { DateIcon } from 'assets/icons';

const width = window.innerWidth;
const windowSize = Math.max(Math.floor(width / 120), 7);

const DatePicker = ({
  disabled,
  error,
  minDate,
  dateValue,
  dateOnChange,
  setTimelineState,
  setDate,
  additionalstyle,
  variant
}) => {

  //remove ownerState warning from MUI icon
  const CleanDateIcon = React.forwardRef(({ ownerState, ...props }, ref) => (
    <DateIcon ref={ref} {...props} />
  ));

  const onClickChange = (newValue) => {
    // change Material UI calendar date
    setDate(moment(newValue).tz(TIME_ZONE));

    //change timeline state to jump to selected date
    setTimelineState && setTimelineState((state) => {
      return {
        ...state,
        visibleTimeStart: moment(newValue)
        .tz(TIME_ZONE)
        .startOf('week')
        .valueOf(),
        visibleTimeEnd: moment(newValue)
        .tz(TIME_ZONE)
        .startOf('week')
        .add(windowSize, 'day')
        .valueOf(),
        today: moment(newValue).tz(TIME_ZONE).startOf('day').valueOf(),
        endToday: moment(newValue).tz(TIME_ZONE).endOf('day').valueOf(),
      };
    });
  };

  return (
    <DatePickerContainer additionalstyle={additionalstyle} disabled={disabled}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          slots={{
            openPickerIcon: CleanDateIcon,
            textField: TextField,
          }}
          slotProps={{
            textField: {
              variant,
              autoComplete: "off",
              error: Boolean(error),
              helperText: error ? "Invalid date" : "",
            },
          }}
          disabled={disabled}
          minDate={minDate}
          fullWidth
          label=" "
          inputFormat="MM/dd/yyyy"
          error={error}
          value={dateValue}
          onChange={dateOnChange ? dateOnChange : onClickChange}
        />
      </LocalizationProvider>
    </DatePickerContainer>
  );
};

export default DatePicker;